import { render } from "./single-upload.vue?vue&type=template&id=ff80cc5c"
import script from "./single-upload.vue?vue&type=script&lang=js"
export * from "./single-upload.vue?vue&type=script&lang=js"
script.render = render

export default script